
export default class navMenu {
	constructor(menu) {
    this.menu = menu;
		this.menuItems = this.menu.querySelectorAll('.menu-item-has-children');

		this.menuItems.forEach((item, index) => {
			let toggle = item.querySelector('.js-menu-item-arrow');
			let subMenu = item.querySelector('.sub-menu');
			let timerOpen;
			let timerClose;
			let mouseInside = false;
			
			this.setAttributes(toggle, subMenu, index);
			this.bindEvents(item, toggle, timerOpen, timerClose, mouseInside);
		});

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      this.menuItems.forEach(item => {
        if (item.classList.contains('is-active')) {
          let toggle = item.querySelector('.js-menu-item-arrow');
          this.close(item, toggle);
        }
      });
    });
	}
	setAttributes(toggle, subMenu, index) {
		toggle.setAttribute('id', `sub-menu-toggle-${index}`);
		toggle.setAttribute('aria-controls', `sub-menu-${index}`);
		subMenu.setAttribute('id', `sub-menu-${index}`);
		subMenu.setAttribute('aria-labelledby', `sub-menu-toggle-${index}`);
		subMenu.setAttribute('role', 'region');
	}
	bindEvents(menuItem, toggle, timerOpen, timerClose, mouseInside) {
		toggle.addEventListener('click', event => {
			this.toggle(menuItem, toggle);
		});
		menuItem.addEventListener('mouseenter', event => {
			mouseInside = true;
			timerOpen = setTimeout(event => {
				if (! mouseInside) return;
        this.open(menuItem, toggle);
        clearTimeout(timerClose);
      }, 300);
		});
		menuItem.addEventListener('mouseleave', event => {
			mouseInside = false;
			timerClose = setTimeout(event => {
				if (mouseInside) return;
				this.close(menuItem, toggle);
				clearTimeout(timerOpen);
			}, 600);
		});
		menuItem.addEventListener('focusout', event => {
			// close menu when navigating focus outside of it
			if (menuItem.contains(event.relatedTarget)) return;
			this.close(menuItem, toggle);
		});
	}
	open(menuItem, toggle) {
		menuItem.classList.add('is-active');
		toggle.setAttribute('aria-expanded', true);
	}
	close(menuItem, toggle) {
		menuItem.classList.remove('is-active');
		toggle.setAttribute('aria-expanded', false);
	}
  toggle(menuItem, toggle) {
    if (toggle.getAttribute('aria-expanded') === 'true')  this.close(menuItem, toggle);
    else																									this.open(menuItem, toggle);
  }
	// closeOthers(menuItem) {
	// 	this.menuItems.forEach((item, index) => {
	// 		if (item != menuItem && item.classList.contains('is-active')) {
	// 			let toggle = item.querySelector('.js-menu-item-arrow');
	// 			this.close(item, toggle);
	// 		}
	// 	});
	// }
}
